import {z} from 'zod'

import {CapacityBucketSchema} from './common'

const ProspectsByGivingLevelRowSchema = z
    .object({
        capacity_bucket: CapacityBucketSchema,
        prospects: z.number(),
        low_total_estimate: z.string(),
        high_total_estimate: z.string(),
    })
    .transform(({capacity_bucket, prospects, low_total_estimate, high_total_estimate}) => ({
        capacityBucket: capacity_bucket,
        prospects,
        lowTotalEstimate: low_total_estimate,
        highTotalEstimate: high_total_estimate,
    }))

export const ProspectsByGivingLevelDataSchema = z
    .object({
        rows: z.array(ProspectsByGivingLevelRowSchema),
        total_low_estimate: z.string(),
        total_high_estimate: z.string(),
    })
    .transform(({rows, total_low_estimate, total_high_estimate}) => ({
        rows,
        totalLowEstimate: total_low_estimate,
        totalHighEstimate: total_high_estimate,
    }))

export type ProspectsByGivingLevelData = z.infer<typeof ProspectsByGivingLevelDataSchema>
